import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Sparkles, Printer, Palette, Award, Truck, PackageCheck } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Sparkles: Sparkles,
  Printer: Printer,
  Palette: Palette,
  Award: Award,
  Truck: Truck,
  PackageCheck: PackageCheck
};

const ServicesSection = () => {
  const { services } = mockData;

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive uniform solutions tailored to your business needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className={`border-2 hover:shadow-xl transition-all duration-300 group ${
                  service.featured
                    ? 'border-green-600 bg-green-50'
                    : 'border-gray-100 hover:border-blue-900'
                }`}
              >
                <CardHeader>
                  <div className="flex items-start justify-between mb-4">
                    <div
                      className={`w-14 h-14 rounded-lg flex items-center justify-center ${
                        service.featured
                          ? 'bg-green-600'
                          : 'bg-blue-100 group-hover:bg-blue-900'
                      } transition-colors duration-300`}
                    >
                      <IconComponent
                        className={`h-7 w-7 ${
                          service.featured
                            ? 'text-white'
                            : 'text-blue-900 group-hover:text-white'
                        } transition-colors duration-300`}
                      />
                    </div>
                    {service.featured && (
                      <Badge className="bg-green-600 text-white">Featured</Badge>
                    )}
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
